// ** Daily Report API
import showLoader from '@components/loader';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import { setLoading } from '../../../../@core/components/skelton/store';

// Fetch Daily Report
export const fetchDailyReport = createAsyncThunk('dailyReportSlice/fetchDailyReport', async (_,{dispatch}) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('/daily-report', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('Error fetching daily report:', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// Post Daily Report Time
export const postDailyReportTime = createAsyncThunk('dailyReportSlice/postDailyReportTime', async (data, { dispatch }) => {
    try {
        showLoader(true);
        let response = await axios.put('/daily-report-configuration', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        dispatch(fetchDailyReport());
        toast.success(response?.data?.message || 'Daily Report updated successfully.');
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        showLoader(false);
        console.log('Error updating daily report time:', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// Daily Report Slice
export const dailyReportSlice = createSlice({
    name: 'dailyReportSlice',
    initialState: {
        reportData: [], 
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchDailyReport.fulfilled, (state, action) => {
            state.reportData = action.payload||[]; 
        });
    }
});

export default dailyReportSlice.reducer;
